import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import evaluationReducer from './slices/evaluationSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    evaluations: evaluationReducer,
  },
});

export default store;
